module.exports = __webpack_public_path__ + "static/media/thumbnail1.6e0c6773.png";